// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header-1ZWTD";
var _3 = "legNumber-2m6zW";
var _4 = "title__text-HGZT4";
var _5 = "title__cities-ffMPP";
var _6 = "diagram-JzkLq";
export { _1 as "__esModule", _2 as "header", _3 as "legNumber", _4 as "title__text", _5 as "title__cities", _6 as "diagram" }
export default { "__esModule": _1, "header": _2, "legNumber": _3, "title__text": _4, "title__cities": _5, "diagram": _6 }
